import React from 'react';

import "./EventImage.scss";
import { ImgStore } from '../../../../elements/ImgStore/ImgStore';

export const EventImage = ({ value })=>{
    return (
        <ImgStore className="EventImage" src={value || "eventImgDefault.webp"}/>
    );
};
